import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 12.324c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1.8c0-3.63-2.65-6.2-6-6.2s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zm-6-8.2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8 0-4.98 3.8-8.2 8-8.2z" fill="#444" /></svg>;